/* global CVP */

// ### Dom
//
// Collection of DOM-related methods.

'use strict';

var _ = require('./vendor/underscore');
var Util = require('./util');


function create(tag) {
	return document.createElement(tag);
}

function id(elId) {
	return document.getElementById(elId);
}

function tags(tagName, root) {
	root = root || document;
	return _.toArray(document.getElementsByTagName(tagName));
}

// IE9+
function classes(className) {
	return _.toArray(document.getElementsByClassName(className));
}

// Note: The selector is scoped to the document, like the selector would be for CSS;
// the method simply filters matching elements that are descendants of the root.
// Make sure to provide very specific selectors, as you'd write a rule in CSS.
// Future: replaced by findAll()
function all(selector, root) {
	root = root || document;
	return _.toArray(root.querySelectorAll(selector));
}

// Note: The selector is scoped to the document, like the selector would be for CSS;
// the method simply filters matching elements that are descendants of the root.
// Make sure to provide very specific selectors, as you'd write a rule in CSS.
// Future: replaced by find()
function one(selector, root) {
	root = root || document;
	return root.querySelector(selector);
}


function text(el, content) {
	var prop = 'textContent' in el ? 'textContent' : 'innerText';
	if (arguments.length === 1) {
		return el[prop];
	}
	el[prop] = content;
	return el[prop];
}

function html(el, content) {
	if (arguments.length === 1) {
		return el.innerHTML;
	}
	el.innerHTML = content;
	return el.innerHTML;
}


// `matches(element, selector)` returns true/false if element matches selector.

function ifNodeIsThis(node) {
	/* jshint validthis:true */
	return node === this;
}

function matchesSelector(selector) {
	/* jshint validthis:true */
	return _.some(all(selector, this), _.bind(ifNodeIsThis, this));
}

function matches(el, selector) {
	var fn = el.matches
		|| el.matchesSelector
		|| el.webkitMatchesSelector
		|| el.msMatchesSelector
		|| el.mozMatchesSelector
		|| el.oMatchesSelector
		|| matchesSelector
	;

	return fn.call(el, selector);
}


// `children(element)` returns child elements of param.

function ifNodeIsElement(node) {
	return node !== null && node.nodeType === 1;
}

function ifNodeIsElementAndMatches(node, selector) {
	return ifNodeIsElement(node) && (!selector || matches(node, selector));
}

// node.children in <IE9 includes comment nodes
// TODO create browser test for comment node issue and create the appropriate fn
function children(el, selector) {
	var childNodes = _.toArray(el.children);
	if (!selector) {
		return _.filter(childNodes, ifNodeIsElement);
	}
	return _.filter(childNodes, function (node) {
		return ifNodeIsElementAndMatches(node, selector);
	});
}

function next(el, selector) {
	var node = el.nextSibling;
	if (ifNodeIsElementAndMatches(node, selector)) {
		return node;
	}
	return next(node, selector);
}

function nextAll(el, selector) {
	var siblings = [];
	while (el.nextSibling) {
		el = el.nextSibling;
		if (ifNodeIsElementAndMatches(el, selector)) {
			siblings.push(el);
		}
	}
	return siblings;
}

function prev(el, selector) {
	var node = el.previousSibling;
	if (ifNodeIsElementAndMatches(node, selector)) {
		return node;
	}
	return prev(node);
}

function prevAll(el, selector) {
	var siblings = [];
	while (el.previousSibling) {
		el = el.previousSibling;
		if (ifNodeIsElementAndMatches(el, selector)) {
			siblings.push(el);
		}
	}
	return siblings;
}


var whitespaceRegex = /\s+/;
var ProtoArray = Array.prototype;
var __push = ProtoArray.push;
var __join = ProtoArray.join;
var __splice = ProtoArray.splice;
var __indexOf = ProtoArray.indexOf || function (item) {
	for (var i = 0, l = this.length; i < l; i += 1) {
		if (this[i] === item) {
			return i;
		}
	}
	return -1;
};

function ClassList(el) {
	this._element = el;

	if (el.className !== this._classCache) {
		this._classCache = el.className;

		if (!this._classCache) {
			return;
		}

		// The className needs to be trimmed and split on whitespace
		// to retrieve a list of classes.
		var classes = _.uniq(Util.trim(this._classCache).split(whitespaceRegex));
		for (var i = 0, endi = classes.length; i < endi; i += 1) {
			__push.call(this, classes[i]);
		}
	}
}

var ClassListProto = ClassList.prototype = [];

ClassListProto._updateClassName = function () {
	this._element.className = this.toString();
};

ClassListProto._indexOf = function (token) {
	return __indexOf.call(this, token);
};

ClassListProto.item = function (index) {
	return this[index] || null;
};

ClassListProto.contains = function (token) {
	return this._indexOf(token) !== -1;
};

ClassListProto.add = function (token) {
	if (this.contains(token)) {
		return;
	}
	__push.call(this, token);
	this._updateClassName();
};

ClassListProto.remove = function (token) {
	var i = this._indexOf(token);
	if (i === -1) {
		return;
	}
	__splice.call(this, i, 1);
	this._updateClassName();
};

ClassListProto.toString = function () {
	return __join.call(this, ' ');
};

ClassListProto.toggle = function (token) {
	if (this.contains(token)) {
		this.remove(token);
	} else {
		this.add(token);
	}
	return this.contains(token);
};

// ClassListProto.toggle = function (token, desired) {
// 	var present = this.contains(token);
// 	if (present && desired !== true) {
// 		this.remove(token);
// 	} else if (!present && desired !== false) {
// 		this.add(token);
// 	}
// 	return this.contains(token);
// };


function classList(el) {
	return 'classList' in el ? el.classList : new ClassList(el);
}


function contains(ancestor, descendant) {
	return ancestor.contains(descendant);
}

function parent(el) {
	return el.parentNode;
}

function siblings(el) {
	var parentNode = parent(el);
	var siblingNodes = [];
	if (parentNode) {
		siblingNodes = children(parentNode);
		siblingNodes = _.reject(siblingNodes, _.bind(ifNodeIsThis, el));
	}
	return siblingNodes;
}

function attr(el, key, val) {
	if (arguments.length === 2) {
		return el.getAttribute(key);
	}
	if (val === null) {
		return el.removeAttribute(key);
	}
	return el.setAttribute(key, val);
}

function append(child, parent) {
	parent = parent || document.body;
	return parent.appendChild(child);
}


function display(el, show) {
	if (show) {
		var prevDisplay = attr(el, 'data-prevDisplay');
		el.style.display = prevDisplay === null ? 'block' : prevDisplay;
	} else {
		var currDisplay = el.style.display;
		if (currDisplay !== 'none') {
			attr(el, 'data-prevDisplay', currDisplay);
		}
		el.style.display = 'none';
	}
	return el;
}

function hide(el) {
	return display(el, false);
}

function show(el) {
	return display(el, true);
}


function documentWidth() {
	return Math.max(
		document.documentElement.clientWidth || 0,
		document.body.clientWidth || 0
	);
}

function documentHeight() {
	return Math.max(
		document.documentElement.clientHeight || 0,
		document.body.clientHeight || 0
	);
}

function viewportWidth() {
	return (
		typeof window.innerWidth === 'number'
		? window.innerWidth
		: document.documentElement.clientWidth
	);
}

function viewportHeight() {
	return (
		typeof window.innerHeight === 'number'
		? window.innerHeight
		: document.documentElement.clientHeight
	);
}

function scrollLeft() {
	return Math.max(
		window.pageXOffset || 0,
		document.documentElement.scrollLeft || 0,
		document.body.scrollLeft || 0
	);
}

function scrollTop() {
	return Math.max(
		window.pageYOffset || 0,
		document.documentElement.scrollTop || 0,
		document.body.scrollTop || 0
	);
}

function getStyle(el, prop) {
	if ('getComputedStyle' in window) {
		return window.getComputedStyle(el, null).getPropertyValue(prop);
	}
	if ('currentStyle' in el) {
		return el.currentStyle[prop];
	}
}

function center(domElement) {

	if (_.isString(domElement)) {
		// just in case someone passed an id instead of an element
		domElement = id(domElement);
	}

	if (!domElement) {
		return;
	}

	var isFixed = getStyle(domElement, 'position') === 'fixed';
	var domElemStyle = domElement.style;
	var elementWidth = 0;
	var elementHeight = 0;
	var leftOffset = 0;
	var topOffset = 0;
	var scrolledX = isFixed ? 0 : scrollLeft();
	var scrolledY = isFixed ? 0 : scrollTop();
	var viewportX = viewportWidth();
	var viewportY = viewportHeight();

	elementWidth = getStyle(domElement, 'width');
	elementHeight = getStyle(domElement, 'height');

	if (elementWidth === undefined) {
		if ('offsetWidth' in domElement) {
			elementWidth = domElement.offsetWidth;
		} else {
			elementWidth = domElemStyle.width;
		}
	}

	if (elementHeight === undefined) {
		if ('offsetHeight' in domElement) {
			elementHeight = domElement.offsetHeight;
		} else {
			elementHeight = domElemStyle.height;
		}
	}

	elementWidth = Util.toInt(elementWidth);
	elementHeight = Util.toInt(elementHeight);

	// defaults are used if element is larger than viewport
	leftOffset = scrolledX;
	topOffset = scrolledY;

	if (viewportX > elementWidth) {
		leftOffset = scrolledX + ((viewportX - elementWidth) / 2);
	}
	if (viewportY > elementHeight) {
		topOffset = scrolledY + ((viewportY - elementHeight) / 2);
	}

	domElemStyle.top = String(Math.round(topOffset)) + 'px';
	domElemStyle.left = String(Math.round(leftOffset)) + 'px';

}


function remove(element) {
	while (element.firstChild) {
		element.removeChild(element.firstChild);
	}
	if (element.parentNode) {
		element.parentNode.removeChild(element);
	}
}


function decodeHtml(encodedHtml) {
	var res = {};
	var encodedRegex = /\&(\#|lt|gt|amp)/;
	var root = (
		('implementation' in document && 'createHTMLDocument' in document.implementation)
		? document.implementation.createHTMLDocument('').body
		: document.createElement('div')
	);

	// insert HTML into DOM
	html(root, encodedHtml);

	// re-insert to decode encoded HTML
	if (encodedRegex.test(encodedHtml)) {
		html(root, text(root));
	}

	// anti-XSS
	_.each(all('script, style, img, object, iframe', root), remove);

	res.html = html(root);
	res.text = text(root);

	return res;
}


exports.on = CVP.Events.addListener;
exports.off = CVP.Events.removeListener;
exports.ready = CVP.Events.onReady;

exports.create = create;
exports.id = id;
exports.tags = tags;
exports.classes = classes;
exports.all = all;
exports.one = one;
exports.text = text;
exports.html = html;
exports.matches = matches;
exports.children = children;
exports.next = next;
exports.nextAll = nextAll;
exports.prev = prev;
exports.prevAll = prevAll;

exports.classList = classList;
exports.contains = contains;
exports.parent = parent;
exports.siblings = siblings;
exports.attr = attr;
exports.append = append;
exports.hide = hide;
exports.show = show;
exports.documentWidth = documentWidth;
exports.documentHeight = documentHeight;
exports.viewportWidth = viewportWidth;
exports.viewportHeight = viewportHeight;
exports.scrollLeft = scrollLeft;
exports.scrollTop = scrollTop;
exports.getStyle = getStyle;
exports.center = center;
exports.remove = remove;
exports.decodeHtml = decodeHtml;
